import npsAnalyticsService from '../../../services/nps-analytics-service'

// ------------------------------------
// Constants
// ------------------------------------
let lOAD_NPS_SEGMENT = 'lOAD_NPS_SEGMENT';

export function loadNpsUserSegment(filter) {
  return (dispatch, getState) => {
    return npsAnalyticsService.getNpsUserSegment(filter)
      .then((npsUserSegment) => {
        dispatch({
          type: lOAD_NPS_SEGMENT,
          npsUserSegment: npsUserSegment
        })
      })
  }
}

// ------------------------------------
// Reducer
// ------------------------------------

export function loadNpsReducer(state = {stores: []}, action) {
  switch (action.type) {
    case lOAD_NPS_SEGMENT: {
      return action.npsUserSegment
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/routes/NetPromotersScoreAnalytics/modules/NetPromotersScoreAnalytics.js